import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container my-5 pt-2">
      {/* Title */}
      <h1 className="fw-bold mb-4  mt-5" style={{ color: "#153555" }}>
        Privacy Policy
      </h1>

      {/* Introduction */}
      <h4 className="fw-semibold mt-4">Introduction</h4>
      <p className="text-secondary">
        This Privacy Policy explains how Fred Hour Pvt. Ltd. collects, uses, and protects your information
        when you use our applications and services.
        <br />
        Fred Hour Pvt. Ltd. provides its applications as free services, intended for use as-is. 
        By using our services, you agree to the collection and use of information in accordance with this Privacy Policy.
      </p>

      {/* Information Collection and Use */}
      <h4 className="fw-semibold mt-4">Information Collection and Use</h4>
      <p className="text-secondary">
        For a better experience, we may require you to provide certain personally identifiable information,
        including but not limited to your name, email address, gender, location, and profile images.
        This information is used to provide, operate, and improve our services.
        <br />
        Our applications may also use third-party services that may collect information used to identify users, 
        in accordance with their own privacy policies.
      </p>

      {/* Cookies */}
      <h4 className="fw-semibold mt-4">Cookies</h4>
      <p className="text-secondary">
        Cookies are files with a small amount of data commonly used as anonymous unique identifiers. 
        Our services do not explicitly use cookies; however, third-party libraries or services may 
        use cookies to improve their functionality.
        <br />
        You can choose to accept or refuse cookies. Refusing cookies may limit some features of the service.
      </p>

      {/* Location Information */}
      <h4 className="fw-semibold mt-4">Location Information</h4>
      <p className="text-secondary">
        Some services may collect approximate location information transmitted from your device. 
        This information is used only to provide relevant functionality within the application 
        and is not used for continuous tracking.
      </p>

      {/* Device Information */}
      <h4 className="fw-semibold mt-4">Device Information</h4>
      <p className="text-secondary">
        We may collect limited device information, including device identifiers (such as Device ID), 
        to improve service quality, ensure application security, and prevent fraudulent activities. 
        This information is not used for advertising or cross-app tracking.
      </p>

      {/* Service Providers */}
      <h4 className="fw-semibold mt-4">Service Providers</h4>
      <p className="text-secondary">
        We may employ third-party companies and individuals to facilitate our services, perform 
        service-related tasks, or help analyze usage. These third parties have access to personal 
        information only to perform assigned tasks and are obligated to keep it confidential.
      </p>

      {/* Security */}
      <h4 className="fw-semibold mt-4">Security</h4>
      <p className="text-secondary">
        We value your trust and strive to use commercially acceptable means to protect your personal 
        information. However, no method of transmission over the internet or electronic storage 
        is completely secure, and we cannot guarantee absolute security.
      </p>

      {/* Children’s Privacy */}
      <h4 className="fw-semibold mt-4">Children’s Privacy</h4>
      <p className="text-secondary">
        Our services do not address anyone under the age of 13. We do not knowingly collect personal 
        information from children under 13. If such information is discovered, it will be deleted 
        immediately.
      </p>

      {/* Account Deletion */}
      <h4 className="fw-semibold mt-4">Account Deletion</h4>
      <p className="text-secondary">
        Users may request deletion of their account and associated personal data at any time. 
        Detailed instructions for requesting account deletion are provided on our Account Deletion page.
        <br />
        Upon successful verification, personal data including account information, usage data, 
        and device identifiers will be permanently removed, subject to any required legal or 
        security-related retention periods.
      </p>

      {/* Changes to Policy */}
      <h4 className="fw-semibold mt-4">Changes to This Privacy Policy</h4>
      <p className="text-secondary">
        We may update this Privacy Policy from time to time. Any changes will be effective immediately 
        upon posting on this page. Users are advised to review this page periodically for updates.
      </p>

      {/* Contact Us */}
      <h4 className="fw-semibold mt-4">Contact Us</h4>
      <p className="text-secondary">
        If you have any questions or concerns about this Privacy Policy or our data practices, 
        please contact us:
        <br />
        <strong>Email:</strong> info@fredhour.com.np
        <br />
        <strong>Company:</strong> Fred Hour Pvt. Ltd.
      </p>
    </div>
  );
};

export default PrivacyPolicy;